import e, { useState as t, createContext as n, useContext as r } from "react";
import o from "react-dom";

function a(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

function i(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var s = i(function (e) {
  e.exports = function (e) {
    if (Array.isArray(e)) return e;
  }, e.exports.default = e.exports, e.exports.__esModule = !0;
});
a(s);
var c = i(function (e) {
  e.exports = function (e, t) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
      var n = [],
          r = !0,
          o = !1,
          a = void 0;

      try {
        for (var i, s = e[Symbol.iterator](); !(r = (i = s.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, a = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (o) throw a;
        }
      }

      return n;
    }
  }, e.exports.default = e.exports, e.exports.__esModule = !0;
});
a(c);
var p = i(function (e) {
  e.exports = function (e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }, e.exports.default = e.exports, e.exports.__esModule = !0;
});
a(p);
var u = i(function (e) {
  e.exports = function (e, t) {
    if (e) {
      if ("string" == typeof e) return p(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? p(e, t) : void 0;
    }
  }, e.exports.default = e.exports, e.exports.__esModule = !0;
});
a(u);
var l = i(function (e) {
  e.exports = function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }, e.exports.default = e.exports, e.exports.__esModule = !0;
});
a(l);
var f = a(i(function (e) {
  e.exports = function (e, t) {
    return s(e) || c(e, t) || u(e, t) || l();
  }, e.exports.default = e.exports, e.exports.__esModule = !0;
}));

function b() {
  return (b = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function d(e, t) {
  if (null == e) return {};
  var n,
      r,
      o = {},
      a = Object.keys(e);

  for (r = 0; r < a.length; r++) {
    n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
  }

  return o;
}

function m(e, t) {
  return (m = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function y(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, m(e, t);
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var _ = "function" == typeof Symbol && Symbol.for,
    v = _ ? Symbol.for("react.element") : 60103,
    x = _ ? Symbol.for("react.portal") : 60106,
    h = _ ? Symbol.for("react.fragment") : 60107,
    k = _ ? Symbol.for("react.strict_mode") : 60108,
    g = _ ? Symbol.for("react.profiler") : 60114,
    E = _ ? Symbol.for("react.provider") : 60109,
    S = _ ? Symbol.for("react.context") : 60110,
    w = _ ? Symbol.for("react.async_mode") : 60111,
    O = _ ? Symbol.for("react.concurrent_mode") : 60111,
    C = _ ? Symbol.for("react.forward_ref") : 60112,
    N = _ ? Symbol.for("react.suspense") : 60113,
    T = _ ? Symbol.for("react.suspense_list") : 60120,
    j = _ ? Symbol.for("react.memo") : 60115,
    M = _ ? Symbol.for("react.lazy") : 60116,
    P = _ ? Symbol.for("react.block") : 60121,
    R = _ ? Symbol.for("react.fundamental") : 60117,
    $ = _ ? Symbol.for("react.responder") : 60118,
    A = _ ? Symbol.for("react.scope") : 60119;

function I(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;

    switch (t) {
      case v:
        switch (e = e.type) {
          case w:
          case O:
          case h:
          case g:
          case k:
          case N:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case S:
              case C:
              case M:
              case j:
              case E:
                return e;

              default:
                return t;
            }

        }

      case x:
        return t;
    }
  }
}

function D(e) {
  return I(e) === O;
}

var V = {
  AsyncMode: w,
  ConcurrentMode: O,
  ContextConsumer: S,
  ContextProvider: E,
  Element: v,
  ForwardRef: C,
  Fragment: h,
  Lazy: M,
  Memo: j,
  Portal: x,
  Profiler: g,
  StrictMode: k,
  Suspense: N,
  isAsyncMode: function isAsyncMode(e) {
    return D(e) || I(e) === w;
  },
  isConcurrentMode: D,
  isContextConsumer: function isContextConsumer(e) {
    return I(e) === S;
  },
  isContextProvider: function isContextProvider(e) {
    return I(e) === E;
  },
  isElement: function isElement(e) {
    return "object" == typeof e && null !== e && e.$$typeof === v;
  },
  isForwardRef: function isForwardRef(e) {
    return I(e) === C;
  },
  isFragment: function isFragment(e) {
    return I(e) === h;
  },
  isLazy: function isLazy(e) {
    return I(e) === M;
  },
  isMemo: function isMemo(e) {
    return I(e) === j;
  },
  isPortal: function isPortal(e) {
    return I(e) === x;
  },
  isProfiler: function isProfiler(e) {
    return I(e) === g;
  },
  isStrictMode: function isStrictMode(e) {
    return I(e) === k;
  },
  isSuspense: function isSuspense(e) {
    return I(e) === N;
  },
  isValidElementType: function isValidElementType(e) {
    return "string" == typeof e || "function" == typeof e || e === h || e === O || e === g || e === k || e === N || e === T || "object" == typeof e && null !== e && (e.$$typeof === M || e.$$typeof === j || e.$$typeof === E || e.$$typeof === S || e.$$typeof === C || e.$$typeof === R || e.$$typeof === $ || e.$$typeof === A || e.$$typeof === P);
  },
  typeOf: I
},
    L = i(function (e, t) {
  "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
        n = e ? Symbol.for("react.element") : 60103,
        r = e ? Symbol.for("react.portal") : 60106,
        o = e ? Symbol.for("react.fragment") : 60107,
        a = e ? Symbol.for("react.strict_mode") : 60108,
        i = e ? Symbol.for("react.profiler") : 60114,
        s = e ? Symbol.for("react.provider") : 60109,
        c = e ? Symbol.for("react.context") : 60110,
        p = e ? Symbol.for("react.async_mode") : 60111,
        u = e ? Symbol.for("react.concurrent_mode") : 60111,
        l = e ? Symbol.for("react.forward_ref") : 60112,
        f = e ? Symbol.for("react.suspense") : 60113,
        b = e ? Symbol.for("react.suspense_list") : 60120,
        d = e ? Symbol.for("react.memo") : 60115,
        m = e ? Symbol.for("react.lazy") : 60116,
        y = e ? Symbol.for("react.block") : 60121,
        _ = e ? Symbol.for("react.fundamental") : 60117,
        v = e ? Symbol.for("react.responder") : 60118,
        x = e ? Symbol.for("react.scope") : 60119;

    function h(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case n:
            var b = e.type;

            switch (b) {
              case p:
              case u:
              case o:
              case i:
              case a:
              case f:
                return b;

              default:
                var y = b && b.$$typeof;

                switch (y) {
                  case c:
                  case l:
                  case m:
                  case d:
                  case s:
                    return y;

                  default:
                    return t;
                }

            }

          case r:
            return t;
        }
      }
    }

    var k = p,
        g = u,
        E = c,
        S = s,
        w = n,
        O = l,
        C = o,
        N = m,
        T = d,
        j = r,
        M = i,
        P = a,
        R = f,
        $ = !1;

    function A(e) {
      return h(e) === u;
    }

    t.AsyncMode = k, t.ConcurrentMode = g, t.ContextConsumer = E, t.ContextProvider = S, t.Element = w, t.ForwardRef = O, t.Fragment = C, t.Lazy = N, t.Memo = T, t.Portal = j, t.Profiler = M, t.StrictMode = P, t.Suspense = R, t.isAsyncMode = function (e) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(e) || h(e) === p;
    }, t.isConcurrentMode = A, t.isContextConsumer = function (e) {
      return h(e) === c;
    }, t.isContextProvider = function (e) {
      return h(e) === s;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, t.isForwardRef = function (e) {
      return h(e) === l;
    }, t.isFragment = function (e) {
      return h(e) === o;
    }, t.isLazy = function (e) {
      return h(e) === m;
    }, t.isMemo = function (e) {
      return h(e) === d;
    }, t.isPortal = function (e) {
      return h(e) === r;
    }, t.isProfiler = function (e) {
      return h(e) === i;
    }, t.isStrictMode = function (e) {
      return h(e) === a;
    }, t.isSuspense = function (e) {
      return h(e) === f;
    }, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === u || e === i || e === a || e === f || e === b || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === d || e.$$typeof === s || e.$$typeof === c || e.$$typeof === l || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === x || e.$$typeof === y);
    }, t.typeOf = h;
  }();
}),
    F = (L.AsyncMode, L.ConcurrentMode, L.ContextConsumer, L.ContextProvider, L.Element, L.ForwardRef, L.Fragment, L.Lazy, L.Memo, L.Portal, L.Profiler, L.StrictMode, L.Suspense, L.isAsyncMode, L.isConcurrentMode, L.isContextConsumer, L.isContextProvider, L.isElement, L.isForwardRef, L.isFragment, L.isLazy, L.isMemo, L.isPortal, L.isProfiler, L.isStrictMode, L.isSuspense, L.isValidElementType, L.typeOf, i(function (e) {
  "production" === process.env.NODE_ENV ? e.exports = V : e.exports = L;
})),
    z = Object.getOwnPropertySymbols,
    Y = Object.prototype.hasOwnProperty,
    q = Object.prototype.propertyIsEnumerable;

function Q(e) {
  if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}

var W = function () {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var t = {}, n = 0; n < 10; n++) {
      t["_" + String.fromCharCode(n)] = n;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
      return t[e];
    }).join("")) return !1;
    var r = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      r[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
  } catch (e) {
    return !1;
  }
}() ? Object.assign : function (e, t) {
  for (var n, r, o = Q(e), a = 1; a < arguments.length; a++) {
    for (var i in n = Object(arguments[a])) {
      Y.call(n, i) && (o[i] = n[i]);
    }

    if (z) {
      r = z(n);

      for (var s = 0; s < r.length; s++) {
        q.call(n, r[s]) && (o[r[s]] = n[r[s]]);
      }
    }
  }

  return o;
},
    G = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    U = function U() {};

if ("production" !== process.env.NODE_ENV) {
  var H = G,
      B = {},
      J = Function.call.bind(Object.prototype.hasOwnProperty);

  U = function U(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  };
}

function X(e, t, n, r, o) {
  if ("production" !== process.env.NODE_ENV) for (var a in e) {
    if (J(e, a)) {
      var i;

      try {
        if ("function" != typeof e[a]) {
          var s = Error((r || "React class") + ": " + n + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[a] + "`.");
          throw s.name = "Invariant Violation", s;
        }

        i = e[a](t, a, r, n, null, H);
      } catch (e) {
        i = e;
      }

      if (!i || i instanceof Error || U((r || "React class") + ": type specification of " + n + " `" + a + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof i + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), i instanceof Error && !(i.message in B)) {
        B[i.message] = !0;
        var c = o ? o() : "";
        U("Failed " + n + " type: " + i.message + (null != c ? c : ""));
      }
    }
  }
}

X.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (B = {});
};

var Z = X,
    K = Function.call.bind(Object.prototype.hasOwnProperty),
    ee = function ee() {};

function te() {
  return null;
}

"production" !== process.env.NODE_ENV && (ee = function ee(e) {
  var t = "Warning: " + e;
  "undefined" != typeof console && console.error(t);

  try {
    throw new Error(t);
  } catch (e) {}
});

var ne = function ne(e, t) {
  var n = "function" == typeof Symbol && Symbol.iterator;
  var r = "<<anonymous>>",
      o = {
    array: c("array"),
    bool: c("boolean"),
    func: c("function"),
    number: c("number"),
    object: c("object"),
    string: c("string"),
    symbol: c("symbol"),
    any: s(te),
    arrayOf: function arrayOf(e) {
      return s(function (t, n, r, o, a) {
        if ("function" != typeof e) return new i("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
        var s = t[n];
        if (!Array.isArray(s)) return new i("Invalid " + o + " `" + a + "` of type `" + u(s) + "` supplied to `" + r + "`, expected an array.");

        for (var c = 0; c < s.length; c++) {
          var p = e(s, c, r, o, a + "[" + c + "]", G);
          if (p instanceof Error) return p;
        }

        return null;
      });
    },
    element: s(function (t, n, r, o, a) {
      var s = t[n];
      return e(s) ? null : new i("Invalid " + o + " `" + a + "` of type `" + u(s) + "` supplied to `" + r + "`, expected a single ReactElement.");
    }),
    elementType: s(function (e, t, n, r, o) {
      var a = e[t];
      return F.isValidElementType(a) ? null : new i("Invalid " + r + " `" + o + "` of type `" + u(a) + "` supplied to `" + n + "`, expected a single ReactElement type.");
    }),
    instanceOf: function instanceOf(e) {
      return s(function (t, n, o, a, s) {
        if (!(t[n] instanceof e)) {
          var c = e.name || r;
          return new i("Invalid " + a + " `" + s + "` of type `" + (((p = t[n]).constructor && p.constructor.name ? p.constructor.name : r) + "` supplied to `") + o + "`, expected instance of `" + c + "`.");
        }

        var p;
        return null;
      });
    },
    node: s(function (e, t, n, r, o) {
      return p(e[t]) ? null : new i("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
    }),
    objectOf: function objectOf(e) {
      return s(function (t, n, r, o, a) {
        if ("function" != typeof e) return new i("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
        var s = t[n],
            c = u(s);
        if ("object" !== c) return new i("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + r + "`, expected an object.");

        for (var p in s) {
          if (K(s, p)) {
            var l = e(s, p, r, o, a + "." + p, G);
            if (l instanceof Error) return l;
          }
        }

        return null;
      });
    },
    oneOf: function oneOf(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && ee(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), te;

      function t(t, n, r, o, s) {
        for (var c = t[n], p = 0; p < e.length; p++) {
          if (a(c, e[p])) return null;
        }

        var u = JSON.stringify(e, function (e, t) {
          return "symbol" === l(t) ? String(t) : t;
        });
        return new i("Invalid " + o + " `" + s + "` of value `" + String(c) + "` supplied to `" + r + "`, expected one of " + u + ".");
      }

      return s(t);
    },
    oneOfType: function oneOfType(e) {
      if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && ee("Invalid argument supplied to oneOfType, expected an instance of array."), te;

      for (var t = 0; t < e.length; t++) {
        var n = e[t];
        if ("function" != typeof n) return ee("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + f(n) + " at index " + t + "."), te;
      }

      return s(function (t, n, r, o, a) {
        for (var s = 0; s < e.length; s++) {
          if (null == (0, e[s])(t, n, r, o, a, G)) return null;
        }

        return new i("Invalid " + o + " `" + a + "` supplied to `" + r + "`.");
      });
    },
    shape: function shape(e) {
      return s(function (t, n, r, o, a) {
        var s = t[n],
            c = u(s);
        if ("object" !== c) return new i("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");

        for (var p in e) {
          var l = e[p];

          if (l) {
            var f = l(s, p, r, o, a + "." + p, G);
            if (f) return f;
          }
        }

        return null;
      });
    },
    exact: function exact(e) {
      return s(function (t, n, r, o, a) {
        var s = t[n],
            c = u(s);
        if ("object" !== c) return new i("Invalid " + o + " `" + a + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");
        var p = W({}, t[n], e);

        for (var l in p) {
          var f = e[l];
          if (!f) return new i("Invalid " + o + " `" + a + "` key `" + l + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
          var b = f(s, l, r, o, a + "." + l, G);
          if (b) return b;
        }

        return null;
      });
    }
  };

  function a(e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  }

  function i(e) {
    this.message = e, this.stack = "";
  }

  function s(e) {
    if ("production" !== process.env.NODE_ENV) var n = {},
        o = 0;

    function a(a, s, c, p, u, l, f) {
      if (p = p || r, l = l || c, f !== G) {
        if (t) {
          var b = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw b.name = "Invariant Violation", b;
        }

        if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
          var d = p + ":" + c;
          !n[d] && o < 3 && (ee("You are manually calling a React.PropTypes validation function for the `" + l + "` prop on `" + p + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[d] = !0, o++);
        }
      }

      return null == s[c] ? a ? null === s[c] ? new i("The " + u + " `" + l + "` is marked as required in `" + p + "`, but its value is `null`.") : new i("The " + u + " `" + l + "` is marked as required in `" + p + "`, but its value is `undefined`.") : null : e(s, c, p, u, l);
    }

    var s = a.bind(null, !1);
    return s.isRequired = a.bind(null, !0), s;
  }

  function c(e) {
    return s(function (t, n, r, o, a, s) {
      var c = t[n];
      return u(c) !== e ? new i("Invalid " + o + " `" + a + "` of type `" + l(c) + "` supplied to `" + r + "`, expected `" + e + "`.") : null;
    });
  }

  function p(t) {
    switch (typeof t) {
      case "number":
      case "string":
      case "undefined":
        return !0;

      case "boolean":
        return !t;

      case "object":
        if (Array.isArray(t)) return t.every(p);
        if (null === t || e(t)) return !0;

        var r = function (e) {
          var t = e && (n && e[n] || e["@@iterator"]);
          if ("function" == typeof t) return t;
        }(t);

        if (!r) return !1;
        var o,
            a = r.call(t);

        if (r !== t.entries) {
          for (; !(o = a.next()).done;) {
            if (!p(o.value)) return !1;
          }
        } else for (; !(o = a.next()).done;) {
          var i = o.value;
          if (i && !p(i[1])) return !1;
        }

        return !0;

      default:
        return !1;
    }
  }

  function u(e) {
    var t = typeof e;
    return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
      return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
    }(t, e) ? "symbol" : t;
  }

  function l(e) {
    if (null == e) return "" + e;
    var t = u(e);

    if ("object" === t) {
      if (e instanceof Date) return "date";
      if (e instanceof RegExp) return "regexp";
    }

    return t;
  }

  function f(e) {
    var t = l(e);

    switch (t) {
      case "array":
      case "object":
        return "an " + t;

      case "boolean":
      case "date":
      case "regexp":
        return "a " + t;

      default:
        return t;
    }
  }

  return i.prototype = Error.prototype, o.checkPropTypes = Z, o.resetWarningCache = Z.resetWarningCache, o.PropTypes = o, o;
};

function re() {}

function oe() {}

oe.resetWarningCache = re;
var ae = i(function (e) {
  if ("production" !== process.env.NODE_ENV) {
    var t = F;
    e.exports = ne(t.isElement, !0);
  } else e.exports = function () {
    function e(e, t, n, r, o, a) {
      if (a !== G) {
        var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw i.name = "Invariant Violation", i;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: oe,
      resetWarningCache: re
    };
    return n.PropTypes = n, n;
  }();
});

function ie(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}

var se = !1,
    ce = "production" !== process.env.NODE_ENV ? ae.oneOfType([ae.number, ae.shape({
  enter: ae.number,
  exit: ae.number,
  appear: ae.number
}).isRequired]) : null,
    pe = "production" !== process.env.NODE_ENV ? ae.oneOfType([ae.string, ae.shape({
  enter: ae.string,
  exit: ae.string,
  active: ae.string
}), ae.shape({
  enter: ae.string,
  enterDone: ae.string,
  enterActive: ae.string,
  exit: ae.string,
  exitDone: ae.string,
  exitActive: ae.string
})]) : null,
    ue = e.createContext(null),
    le = function (t) {
  function n(e, n) {
    var r;
    r = t.call(this, e, n) || this;
    var o,
        a = n && !n.isMounting ? e.enter : e.appear;
    return r.appearStatus = null, e.in ? a ? (o = "exited", r.appearStatus = "entering") : o = "entered" : o = e.unmountOnExit || e.mountOnEnter ? "unmounted" : "exited", r.state = {
      status: o
    }, r.nextCallback = null, r;
  }

  y(n, t), n.getDerivedStateFromProps = function (e, t) {
    return e.in && "unmounted" === t.status ? {
      status: "exited"
    } : null;
  };
  var r = n.prototype;
  return r.componentDidMount = function () {
    this.updateStatus(!0, this.appearStatus);
  }, r.componentDidUpdate = function (e) {
    var t = null;

    if (e !== this.props) {
      var n = this.state.status;
      this.props.in ? "entering" !== n && "entered" !== n && (t = "entering") : "entering" !== n && "entered" !== n || (t = "exiting");
    }

    this.updateStatus(!1, t);
  }, r.componentWillUnmount = function () {
    this.cancelNextCallback();
  }, r.getTimeouts = function () {
    var e,
        t,
        n,
        r = this.props.timeout;
    return e = t = n = r, null != r && "number" != typeof r && (e = r.exit, t = r.enter, n = void 0 !== r.appear ? r.appear : t), {
      exit: e,
      enter: t,
      appear: n
    };
  }, r.updateStatus = function (e, t) {
    void 0 === e && (e = !1), null !== t ? (this.cancelNextCallback(), "entering" === t ? this.performEnter(e) : this.performExit()) : this.props.unmountOnExit && "exited" === this.state.status && this.setState({
      status: "unmounted"
    });
  }, r.performEnter = function (e) {
    var t = this,
        n = this.props.enter,
        r = this.context ? this.context.isMounting : e,
        a = this.props.nodeRef ? [r] : [o.findDOMNode(this), r],
        i = a[0],
        s = a[1],
        c = this.getTimeouts(),
        p = r ? c.appear : c.enter;
    !e && !n || se ? this.safeSetState({
      status: "entered"
    }, function () {
      t.props.onEntered(i);
    }) : (this.props.onEnter(i, s), this.safeSetState({
      status: "entering"
    }, function () {
      t.props.onEntering(i, s), t.onTransitionEnd(p, function () {
        t.safeSetState({
          status: "entered"
        }, function () {
          t.props.onEntered(i, s);
        });
      });
    }));
  }, r.performExit = function () {
    var e = this,
        t = this.props.exit,
        n = this.getTimeouts(),
        r = this.props.nodeRef ? void 0 : o.findDOMNode(this);
    t && !se ? (this.props.onExit(r), this.safeSetState({
      status: "exiting"
    }, function () {
      e.props.onExiting(r), e.onTransitionEnd(n.exit, function () {
        e.safeSetState({
          status: "exited"
        }, function () {
          e.props.onExited(r);
        });
      });
    })) : this.safeSetState({
      status: "exited"
    }, function () {
      e.props.onExited(r);
    });
  }, r.cancelNextCallback = function () {
    null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
  }, r.safeSetState = function (e, t) {
    t = this.setNextCallback(t), this.setState(e, t);
  }, r.setNextCallback = function (e) {
    var t = this,
        n = !0;
    return this.nextCallback = function (r) {
      n && (n = !1, t.nextCallback = null, e(r));
    }, this.nextCallback.cancel = function () {
      n = !1;
    }, this.nextCallback;
  }, r.onTransitionEnd = function (e, t) {
    this.setNextCallback(t);
    var n = this.props.nodeRef ? this.props.nodeRef.current : o.findDOMNode(this),
        r = null == e && !this.props.addEndListener;

    if (n && !r) {
      if (this.props.addEndListener) {
        var a = this.props.nodeRef ? [this.nextCallback] : [n, this.nextCallback],
            i = a[0],
            s = a[1];
        this.props.addEndListener(i, s);
      }

      null != e && setTimeout(this.nextCallback, e);
    } else setTimeout(this.nextCallback, 0);
  }, r.render = function () {
    var t = this.state.status;
    if ("unmounted" === t) return null;
    var n = this.props,
        r = n.children,
        o = (n.in, n.mountOnEnter, n.unmountOnExit, n.appear, n.enter, n.exit, n.timeout, n.addEndListener, n.onEnter, n.onEntering, n.onEntered, n.onExit, n.onExiting, n.onExited, n.nodeRef, d(n, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]));
    return e.createElement(ue.Provider, {
      value: null
    }, "function" == typeof r ? r(t, o) : e.cloneElement(e.Children.only(r), o));
  }, n;
}(e.Component);

function fe() {}

le.contextType = ue, le.propTypes = "production" !== process.env.NODE_ENV ? {
  nodeRef: ae.shape({
    current: "undefined" == typeof Element ? ae.any : ae.instanceOf(Element)
  }),
  children: ae.oneOfType([ae.func.isRequired, ae.element.isRequired]).isRequired,
  in: ae.bool,
  mountOnEnter: ae.bool,
  unmountOnExit: ae.bool,
  appear: ae.bool,
  enter: ae.bool,
  exit: ae.bool,
  timeout: function timeout(e) {
    var t = ce;
    e.addEndListener || (t = t.isRequired);

    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) {
      r[o - 1] = arguments[o];
    }

    return t.apply(void 0, [e].concat(r));
  },
  addEndListener: ae.func,
  onEnter: ae.func,
  onEntering: ae.func,
  onEntered: ae.func,
  onExit: ae.func,
  onExiting: ae.func,
  onExited: ae.func
} : {}, le.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: fe,
  onEntering: fe,
  onEntered: fe,
  onExit: fe,
  onExiting: fe,
  onExited: fe
}, le.UNMOUNTED = "unmounted", le.EXITED = "exited", le.ENTERING = "entering", le.ENTERED = "entered", le.EXITING = "exiting";

var be = function be(e, t) {
  return e && t && t.split(" ").forEach(function (t) {
    return r = t, void ((n = e).classList ? n.classList.add(r) : function (e, t) {
      return e.classList ? !!t && e.classList.contains(t) : -1 !== (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ");
    }(n, r) || ("string" == typeof n.className ? n.className = n.className + " " + r : n.setAttribute("class", (n.className && n.className.baseVal || "") + " " + r)));
    var n, r;
  });
},
    de = function de(e, t) {
  return e && t && t.split(" ").forEach(function (t) {
    return r = t, void ((n = e).classList ? n.classList.remove(r) : "string" == typeof n.className ? n.className = ie(n.className, r) : n.setAttribute("class", ie(n.className && n.className.baseVal || "", r)));
    var n, r;
  });
},
    me = function (t) {
  function n() {
    for (var e, n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
      r[o] = arguments[o];
    }

    return (e = t.call.apply(t, [this].concat(r)) || this).appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, e.onEnter = function (t, n) {
      var r = e.resolveArguments(t, n),
          o = r[0],
          a = r[1];
      e.removeClasses(o, "exit"), e.addClass(o, a ? "appear" : "enter", "base"), e.props.onEnter && e.props.onEnter(t, n);
    }, e.onEntering = function (t, n) {
      var r = e.resolveArguments(t, n),
          o = r[0],
          a = r[1] ? "appear" : "enter";
      e.addClass(o, a, "active"), e.props.onEntering && e.props.onEntering(t, n);
    }, e.onEntered = function (t, n) {
      var r = e.resolveArguments(t, n),
          o = r[0],
          a = r[1] ? "appear" : "enter";
      e.removeClasses(o, a), e.addClass(o, a, "done"), e.props.onEntered && e.props.onEntered(t, n);
    }, e.onExit = function (t) {
      var n = e.resolveArguments(t)[0];
      e.removeClasses(n, "appear"), e.removeClasses(n, "enter"), e.addClass(n, "exit", "base"), e.props.onExit && e.props.onExit(t);
    }, e.onExiting = function (t) {
      var n = e.resolveArguments(t)[0];
      e.addClass(n, "exit", "active"), e.props.onExiting && e.props.onExiting(t);
    }, e.onExited = function (t) {
      var n = e.resolveArguments(t)[0];
      e.removeClasses(n, "exit"), e.addClass(n, "exit", "done"), e.props.onExited && e.props.onExited(t);
    }, e.resolveArguments = function (t, n) {
      return e.props.nodeRef ? [e.props.nodeRef.current, t] : [t, n];
    }, e.getClassNames = function (t) {
      var n = e.props.classNames,
          r = "string" == typeof n,
          o = r ? "" + (r && n ? n + "-" : "") + t : n[t];
      return {
        baseClassName: o,
        activeClassName: r ? o + "-active" : n[t + "Active"],
        doneClassName: r ? o + "-done" : n[t + "Done"]
      };
    }, e;
  }

  y(n, t);
  var r = n.prototype;
  return r.addClass = function (e, t, n) {
    var r = this.getClassNames(t)[n + "ClassName"],
        o = this.getClassNames("enter").doneClassName;
    "appear" === t && "done" === n && o && (r += " " + o), "active" === n && e && e.scrollTop, r && (this.appliedClasses[t][n] = r, be(e, r));
  }, r.removeClasses = function (e, t) {
    var n = this.appliedClasses[t],
        r = n.base,
        o = n.active,
        a = n.done;
    this.appliedClasses[t] = {}, r && de(e, r), o && de(e, o), a && de(e, a);
  }, r.render = function () {
    var t = this.props,
        n = (t.classNames, d(t, ["classNames"]));
    return e.createElement(le, b({}, n, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, n;
}(e.Component);

me.defaultProps = {
  classNames: ""
}, me.propTypes = "production" !== process.env.NODE_ENV ? b({}, le.propTypes, {
  classNames: pe,
  onEnter: ae.func,
  onEntering: ae.func,
  onEntered: ae.func,
  onExit: ae.func,
  onExiting: ae.func,
  onExited: ae.func
}) : {};
var ye = {
  "snackbar-wrapper": "Snackbar_snackbar-wrapper__ocbPJ",
  "snackbar-wrapper-top-left": "Snackbar_snackbar-wrapper-top-left__kU4xa",
  "snackbar-wrapper-top-center": "Snackbar_snackbar-wrapper-top-center__1Gbfi",
  "snackbar-wrapper-top-right": "Snackbar_snackbar-wrapper-top-right__2CAmf",
  "snackbar-wrapper-bottom-left": "Snackbar_snackbar-wrapper-bottom-left__-7yn0",
  "snackbar-wrapper-bottom-center": "Snackbar_snackbar-wrapper-bottom-center__21ghq",
  "snackbar-wrapper-bottom-right": "Snackbar_snackbar-wrapper-bottom-right__8wQeQ",
  snackbar: "Snackbar_snackbar__GsYZl",
  snackbar__text: "Snackbar_snackbar__text__1Hx2a",
  snackbar__close: "Snackbar_snackbar__close__NCHgT",
  "snackbar-enter": "Snackbar_snackbar-enter__2XoWy",
  "snackbar-exit-active": "Snackbar_snackbar-exit-active__38Ts1",
  "snackbar-enter-active": "Snackbar_snackbar-enter-active__2G0jP",
  "snackbar-enter-top-left": "Snackbar_snackbar-enter-top-left__5McRQ",
  "snackbar-enter-top-center": "Snackbar_snackbar-enter-top-center__2hv_H",
  "snackbar-enter-top-right": "Snackbar_snackbar-enter-top-right__3IZID",
  "snackbar-exit-active-top-left": "Snackbar_snackbar-exit-active-top-left__25M1C",
  "snackbar-exit-active-top-center": "Snackbar_snackbar-exit-active-top-center__3MvcF",
  "snackbar-exit-active-top-right": "Snackbar_snackbar-exit-active-top-right__1QPvY",
  "snackbar-enter-bottom-left": "Snackbar_snackbar-enter-bottom-left__21M-k",
  "snackbar-enter-bottom-center": "Snackbar_snackbar-enter-bottom-center__KWFO3",
  "snackbar-enter-bottom-right": "Snackbar_snackbar-enter-bottom-right__20sEa",
  "snackbar-exit-active-bottom-left": "Snackbar_snackbar-exit-active-bottom-left__2tT-Y",
  "snackbar-exit-active-bottom-center": "Snackbar_snackbar-exit-active-bottom-center__oO6Rn",
  "snackbar-exit-active-bottom-right": "Snackbar_snackbar-exit-active-bottom-right__GOHKw",
  "snackbar-enter-active-top-left": "Snackbar_snackbar-enter-active-top-left__2EQ5v",
  "snackbar-enter-active-top-center": "Snackbar_snackbar-enter-active-top-center__sy6SN",
  "snackbar-enter-active-top-right": "Snackbar_snackbar-enter-active-top-right__1Jhh8",
  "snackbar-enter-active-bottom-left": "Snackbar_snackbar-enter-active-bottom-left__hXac0",
  "snackbar-enter-active-bottom-center": "Snackbar_snackbar-enter-active-bottom-center__2zcYl",
  "snackbar-enter-active-bottom-right": "Snackbar_snackbar-enter-active-bottom-right__2QyBV"
};
!function (e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;

  if (e && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
        o = document.createElement("style");
    o.type = "text/css", "top" === n && r.firstChild ? r.insertBefore(o, r.firstChild) : r.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
}('.Snackbar_snackbar-wrapper__ocbPJ{display:flex;align-items:center;margin:8px;position:fixed;right:0;left:0;z-index:1;transition:opacity .15s,transform .15s;pointer-events:none}.Snackbar_snackbar-wrapper-top-center__1Gbfi,.Snackbar_snackbar-wrapper-top-left__kU4xa,.Snackbar_snackbar-wrapper-top-right__2CAmf{top:8px}.Snackbar_snackbar-wrapper-bottom-center__21ghq,.Snackbar_snackbar-wrapper-bottom-left__-7yn0,.Snackbar_snackbar-wrapper-bottom-right__8wQeQ{bottom:8px}.Snackbar_snackbar-wrapper-bottom-left__-7yn0,.Snackbar_snackbar-wrapper-top-left__kU4xa{justify-content:flex-start}.Snackbar_snackbar-wrapper-bottom-center__21ghq,.Snackbar_snackbar-wrapper-top-center__1Gbfi{justify-content:center}.Snackbar_snackbar-wrapper-bottom-right__8wQeQ,.Snackbar_snackbar-wrapper-top-right__2CAmf{justify-content:flex-end}.Snackbar_snackbar__GsYZl{display:flex;align-items:center;justify-content:flex-start;border-radius:4px;min-width:334px;max-width:672px;background-color:#333;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:sans-serif;font-size:14px;font-weight:400;color:hsla(0,0%,100%,.87);letter-spacing:.25px;line-height:20px;text-align:left}@media (max-width:344px),(max-width:480px){.Snackbar_snackbar__GsYZl{min-width:100%}}.Snackbar_snackbar__text__1Hx2a{flex-grow:1;padding:14px 16px;margin:0;pointer-events:auto}.Snackbar_snackbar__close__NCHgT{flex-shrink:0;box-sizing:border-box;display:flex;align-items:center;justify-content:center;width:36px;height:36px;padding:8px;margin:0 8px 0 0;cursor:pointer;position:relative;pointer-events:auto;-webkit-tap-highlight-color:transparent;outline:none;background-color:transparent;border:none;font-size:12px;color:hsla(0,0%,100%,.87)}.Snackbar_snackbar__close__NCHgT:before{content:"";background-color:#fff;border-radius:50%;opacity:0;position:absolute;transition:opacity .12s linear;top:0;left:0;width:100%;height:100%}@media (hover:hover){.Snackbar_snackbar__close__NCHgT:hover:before{opacity:.08}}.Snackbar_snackbar-enter__2XoWy,.Snackbar_snackbar-exit-active__38Ts1{opacity:0}.Snackbar_snackbar-enter-active__2G0jP{opacity:1}.Snackbar_snackbar-enter-top-center__2hv_H,.Snackbar_snackbar-enter-top-left__5McRQ,.Snackbar_snackbar-enter-top-right__3IZID,.Snackbar_snackbar-exit-active-top-center__3MvcF,.Snackbar_snackbar-exit-active-top-left__25M1C,.Snackbar_snackbar-exit-active-top-right__1QPvY{transform:translateY(-16px)}.Snackbar_snackbar-enter-bottom-center__KWFO3,.Snackbar_snackbar-enter-bottom-left__21M-k,.Snackbar_snackbar-enter-bottom-right__20sEa,.Snackbar_snackbar-exit-active-bottom-center__oO6Rn,.Snackbar_snackbar-exit-active-bottom-left__2tT-Y,.Snackbar_snackbar-exit-active-bottom-right__GOHKw{transform:translateY(16px)}.Snackbar_snackbar-enter-active-bottom-center__2zcYl,.Snackbar_snackbar-enter-active-bottom-left__hXac0,.Snackbar_snackbar-enter-active-bottom-right__2QyBV,.Snackbar_snackbar-enter-active-top-center__sy6SN,.Snackbar_snackbar-enter-active-top-left__2EQ5v,.Snackbar_snackbar-enter-active-top-right__1Jhh8{transform:translateY(0)}');
var _e = ["top-left", "top-center", "top-right", "bottom-left", "bottom-center", "bottom-right"],
    ve = n(null);

function xe(n) {
  var r = n.children,
      o = t(!1),
      a = f(o, 2),
      i = a[0],
      s = a[1],
      c = t(null),
      p = f(c, 2),
      u = p[0],
      l = p[1],
      b = t(""),
      d = f(b, 2),
      m = d[0],
      y = d[1],
      _ = t(5e3),
      v = f(_, 2),
      x = v[0],
      h = v[1],
      k = t("bottom-center"),
      g = f(k, 2),
      E = g[0],
      S = g[1],
      w = t({}),
      O = f(w, 2),
      C = O[0],
      N = O[1],
      T = t({}),
      j = f(T, 2),
      M = j[0],
      P = j[1],
      R = function R(e, t, n, r, o) {
    y(e), h(t), S(n), N(r), P(o), s(!0);
  },
      $ = function $() {
    s(!1);
  };

  return e.createElement(ve.Provider, {
    value: {
      openSnackbar: function openSnackbar(e, t, n, r, o) {
        !0 === i ? (s(!1), setTimeout(function () {
          R(e, t, n, r, o);
        }, 250)) : R(e, t, n, r, o);
      },
      closeSnackbar: $
    }
  }, r, e.createElement(me, {
    in: i,
    timeout: 150,
    mountOnEnter: !0,
    unmountOnExit: !0,
    onEnter: function onEnter() {
      clearTimeout(u), l(setTimeout(function () {
        return s(!1);
      }, x));
    },
    className: "".concat(ye["snackbar-wrapper"], " ").concat(ye["snackbar-wrapper-".concat(E)]),
    classNames: {
      enter: "".concat(ye["snackbar-enter"], " ").concat(ye["snackbar-enter-".concat(E)]),
      enterActive: "".concat(ye["snackbar-enter-active"], " ").concat(ye["snackbar-enter-active-".concat(E)]),
      exitActive: "".concat(ye["snackbar-exit-active"], " ").concat(ye["snackbar-exit-active-".concat(E)])
    }
  }, e.createElement("div", null, e.createElement("div", {
    className: ye.snackbar,
    style: C
  }, e.createElement("div", {
    className: ye.snackbar__text
  }, m), e.createElement("button", {
    onClick: $,
    className: ye.snackbar__close,
    style: M
  }, e.createElement(he, null))))));
}

var he = function he() {
  return e.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12"
  }, e.createElement("path", {
    fill: "currentColor",
    d: "M11.73 1.58L7.31 6l4.42 4.42-1.06 1.06-4.42-4.42-4.42 4.42-1.06-1.06L5.19 6 .77 1.58 1.83.52l4.42 4.42L10.67.52z",
    fillRule: "evenodd"
  }));
},
    ke = function ke() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = e.position,
      n = void 0 === t ? "bottom-center" : t,
      o = e.style,
      a = void 0 === o ? {} : o,
      i = e.closeStyle,
      s = void 0 === i ? {} : i,
      c = r(ve),
      p = c.openSnackbar,
      u = c.closeSnackbar;

  function l() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5e3;
    p(e, t, n, a, s);
  }

  return _e.includes(n) || (n = "bottom-center"), [l, u];
},
    ge = a(i(function (e) {
  function t() {
    return e.exports = t = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0, t.apply(this, arguments);
  }

  e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
})),
    Ee = a(i(function (e) {
  e.exports = function (e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }, e.exports.default = e.exports, e.exports.__esModule = !0;
})),
    Se = a(i(function (e) {
  function t(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  e.exports = function (e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  }, e.exports.default = e.exports, e.exports.__esModule = !0;
})),
    we = i(function (e) {
  e.exports = function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }, e.exports.default = e.exports, e.exports.__esModule = !0;
}),
    Oe = a(we),
    Ce = i(function (e) {
  function t(n, r) {
    return e.exports = t = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0, t(n, r);
  }

  e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
});

a(Ce);
var Ne = a(i(function (e) {
  e.exports = function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && Ce(e, t);
  }, e.exports.default = e.exports, e.exports.__esModule = !0;
})),
    Te = i(function (e) {
  function t(n) {
    return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? (e.exports = t = function t(e) {
      return typeof e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = t = function t(e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    }, e.exports.default = e.exports, e.exports.__esModule = !0), t(n);
  }

  e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
});
a(Te);
var je = a(i(function (e) {
  var t = Te.default;
  e.exports = function (e, n) {
    return !n || "object" !== t(n) && "function" != typeof n ? we(e) : n;
  }, e.exports.default = e.exports, e.exports.__esModule = !0;
})),
    Me = a(i(function (e) {
  function t(n) {
    return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    }, e.exports.default = e.exports, e.exports.__esModule = !0, t(n);
  }

  e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
})),
    Pe = a(i(function (e) {
  e.exports = function (e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }, e.exports.default = e.exports, e.exports.__esModule = !0;
}));

function Re(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = Me(e);

    if (t) {
      var o = Me(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return je(this, n);
  };
}

function $e(t) {
  var n,
      r,
      o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      a = o.position,
      i = void 0 === a ? "bottom-center" : a,
      s = o.style,
      c = void 0 === s ? {} : s,
      p = o.closeStyle,
      u = void 0 === p ? {} : p;
  return r = n = function (n) {
    Ne(o, n);
    var r = Re(o);

    function o(e) {
      var t;
      return Ee(this, o), (t = r.call(this, e)).open = t.open.bind(Oe(t)), t.close = t.close.bind(Oe(t)), t;
    }

    return Se(o, [{
      key: "open",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
            t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 5e3,
            n = this.context.openSnackbar;
        _e.includes(i) || (i = "bottom-center"), n(e, t, i, c, u);
      }
    }, {
      key: "close",
      value: function value() {
        (0, this.context.closeSnackbar)();
      }
    }, {
      key: "render",
      value: function value() {
        return e.createElement(t, ge({
          openSnackbar: this.open,
          closeSnackbar: this.close
        }, this.props));
      }
    }]), o;
  }(e.Component), Pe(n, "contextType", ve), r;
}

export default xe;
export { ke as useSnackbar, $e as withSnackbar };